<template>
  <div>

    <Loader cover v-if="local.isProcessing"/>

    <div class="vx-row ">

      <!--SUBJECT INFORMATION-->
      <div class="vx-col w-full">
        <SubjectInfo :course-outline="courseOutline"/>
      </div>

    </div>

    <!--INSTRUCTION-->
    <div class="vx-row">
      <div class="vx-col sm:w-1/2">
        <InstructionEdit :course-outline="courseOutline"/>
      </div>

      <!--COURSE OUTLINE ASSESSMENT-->
      <div class="vx-col sm:w-1/2">
        <AssessmentEdit :course-outline="courseOutline"/>
      </div>
    </div>

    <!--COURSE OUTLINE ENIT-->
    <div class="vx-row">
      <div class="vx-col w-full">
        <UnitEdit :course-outline="courseOutline"/>
      </div>
    </div>

    <!----------------------------------------- Actions Button ---------------------------------------------------->
    <div class="vx-row">
      <div class="vx-col w-full mt-3">
        <!--<vs-button :disabled="local.isProcessing || invalid " @click.prevent="onSaveClick" class="ml-2"
                   color="primary">
          {{ $t('general.save') }}
        </vs-button>-->
        <vs-button @click.prevent="onCancelClick" class="ml-2" color="success"
                   type="border">
          {{ $t('general.back') }}
        </vs-button>
      </div>
    </div>

  </div>
</template>

<script>
  import SubjectInfo from './Component/SubjectInfo'
  import AssessmentEdit from './Component/AssessmentEdit'
  import InstructionEdit from './Component/InstructionEdit'
  import UnitEdit from './Component/UnitEdit'

  import {state} from './data';
  // import {showStateNotification} from "@/utils/notification";

  import CourseOutline from '@/store/modules/courses/course-outline/index';
  import {createHelpers} from 'vuex-map-fields';
  import {createNamespacedHelpers} from "vuex";

  if (!state.store.CourseOutline) state.registerModule(`CourseOutline`, CourseOutline);

  const {
    mapActions: mapCourseOutlineActions,
  } = createNamespacedHelpers(`CourseOutline`);


  const {
    mapFields: mapCourseOutlineFields,
  } = createHelpers({
    getterType: `CourseOutline/getField`,
    mutationType: `CourseOutline/updateField`,
  });

  export default {
    components: {
      SubjectInfo,
      AssessmentEdit,
      InstructionEdit,
      UnitEdit,

      Loader: () => import('@/components/common-ui/loader-block/index.vue'),
    },
    data() {
      return {
        store: state.store,
        local: state.local,
      }
    },
    computed: {
      ...mapCourseOutlineFields({courseOutlineProcessing: 'processing',courseOutlineSuccess: 'success',courseOutlineError: 'error'}),
      courseOutline() {
        return this.local.courseOutline;
      },
    },
    watch: {
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
      /*courseOutlineSuccess(data) {
        showStateNotification(this.$vs, data);
      },
      courseOutlineError: async function (data) {
        showStateNotification(this.$vs, data);
      },*/
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapCourseOutlineActions({
        getCourseOutline: 'getCourseOutline',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      async onSaveClick() {

      },
      async onCancelClick() {
        this.goBack();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      async saveCourseOutline(){

      },
      goBack() {
        this.$router.push(
          {
            name: "course-outline",
          }
        );

      },
      async loadData() {
        if(this.$route.params.id){
          let result = await this.getCourseOutline({id: this.$route.params.id})

          if(result){
            result = JSON.parse(JSON.stringify(result));

            this.local.courseOutline = result;
          }
        }
      },
    },
    async mounted() {
      await this.loadData();
    }
  }
</script>

<style>
</style>
